import { css } from '@emotion/react'
import { Text } from 'bold-ui'

import { NEWS_FONT_SIZE, NewsContentProps } from './news-commons'

interface NewsListItemProps extends NewsContentProps {
  fontSize?: number
}

export function NewsListItem(props: Readonly<NewsListItemProps>) {
  const { children, fontSize = NEWS_FONT_SIZE } = props

  return (
    <Text fontSize={fontSize} component='li' style={styles.listItem}>
      {children}
    </Text>
  )
}

const styles = {
  listItem: css`
    list-style-position: inside;
  `,
}
